import { render, staticRenderFns } from "./HistoricoTombamentoList.vue?vue&type=template&id=2138f034"
import script from "./HistoricoTombamentoList.vue?vue&type=script&lang=js"
export * from "./HistoricoTombamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports